import * as React from 'react';
export const capitaloneSvg = React.forwardRef(function capitaloneSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M13.033 6.5c-5.7 0-10.389.4-13.033.6v2.933c.733-.033 3.695.186 5.5.467 2.081.324 8.75 1.688 9.344 5s-1.27 5.417-6.633 10.242C4.078 29.461 2.508 30.547.594 32l3.695.008c4.242-2.274 12.094-7.307 15.844-10.175 3.695-2.825 9.938-7.902 8.398-11.302C26.931 6.998 18.133 6.5 13.033 6.5',
          fill: '#CC2427',
        }),
      ),
    ),
  );
});
capitaloneSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var capitalone = {
  category: 'brand',
  colorable: false,
  name: 'capitalone',
  svg: capitaloneSvg,
};
